import {
	CLEAR,
	ERROR,
	SUCCESS,
	LOADING,
	GET_STATUS
} from "./badgeActionsCreator";

const defaultState = {
	loading: true,
	badges: [],
	buildings: [],
	cards: [],
	unassigned: [],
};

export default function badgeReducer(state = defaultState, action) {
	switch (action.type) {
		case LOADING: {
			return {
				...state,
				loading: action.data
			};
		}
		case ERROR: {
			return {
				...state,
				loading: false,
				error: action.data
			};
		}
		case SUCCESS: {
			return {
				...state,
				loading: false,
				success: true
			};
		}
		case CLEAR: {
			return {
				...state,
				loading: false,
				success: false,
				error: null
			};
		}
		case GET_STATUS: {
			let buildings = action.data.buildings.map(b => ({ ...b, devices: [] }))
			let unassigned = []
			action.data.badges.forEach(badge => {
				if (badge.buildingId) {
					let building = buildings.find(b => b.id === badge.buildingId);
					if (building) {
						building.devices.push(badge);
					} else {
						unassigned.push(badge);
					}
				} else {
					unassigned.push(badge);
				}
			})
			return {
				...state,
				loading: false,
				badges: action.data.badges,
				buildings,
				cards: action.data.cards,
				unassigned
			};
		}
		default: return state;
	}

}